<template>
  <div class="cat-list">
    <div class="drap_down">
      <svg
        t="1582095362726"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="7481"
        width="20"
        height="20"
      ><path
        d="M230.6 264h562.8c14.138 0 25.6 11.462 25.6 25.6v0.8c0 14.138-11.462 25.6-25.6 25.6H230.6c-14.138 0-25.6-11.462-25.6-25.6v-0.8c0-14.138 11.462-25.6 25.6-25.6z m0 222h562.8c14.138 0 25.6 11.462 25.6 25.6v0.8c0 14.138-11.462 25.6-25.6 25.6H230.6c-14.138 0-25.6-11.462-25.6-25.6v-0.8c0-14.138 11.462-25.6 25.6-25.6z m0 222h562.8c14.138 0 25.6 11.462 25.6 25.6v0.8c0 14.138-11.462 25.6-25.6 25.6H230.6c-14.138 0-25.6-11.462-25.6-25.6v-0.8c0-14.138 11.462-25.6 25.6-25.6z"
        fill="#fff"
        p-id="7482"
      ></path></svg>
      <span class="hidden-title">{{ union === 'gwgc' ? TLang('劳保用品', 'my') :TLang('优选生活分类', 'my') }}</span>
    </div>
    <div
      ref="$listwrap"
      class="list-wrap"
      :class="{showMoreHeigth: showMore}"
      @mouseleave.prevent="showMore = false; activeItem = null"
    >
      <div
        v-for="cat in catList"
        :key="cat.id"
      >
        <div
          class="drap_down-item"
          @mouseenter="activeItem = cat"
        >
          <img
            :src="cat.icon"
            alt
          />
          <ul
            v-if="cat.compositeCategories && cat.compositeCategories.length"
            class="catefory-list"
          >
            <li
              v-for="(item, index) in cat.compositeCategories"
              :key="item.id"
            >
              <span
                v-if="index > 0"
                class="category-line"
              >/</span>
              <span
                class="category-name"
                @click="
                  onChange(item.id,item,1);
                "
              >{{ item.name }}</span>
            </li>
          </ul>
          <i class="icon iconfont">&#xe657;</i>
        </div>
      </div>

      <div
        v-if="activeItem && activeItem.compositeCategories && activeItem.compositeCategories.length"
        class="rigth_content"
        @mouseleave.stop="activeItem = null;"
      >
        <ul>
          <li
            v-for="item in activeItem.compositeCategories"
            :key="item.id"
          >
            <p>
              <span>{{ item.name }}</span>
              <span
                class="get-more"
                @click="onChange(item.id,item); activeItem = null;"
              >
                <span>{{TLang('更多','my')}}</span>
                <i class="icon iconfont">&#xe657;</i>
              </span>
            </p>
            <div class="sub-list">
              <div
                v-for="goods in item.subCategoryList"
                :key="goods.id"
                class="sub3-item"
                @click="
                  onChange(goods.id,goods,2);
                  activeItem = null;
                "
              >
                {{ goods.name }}
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div
        v-if="catList.length > 10 && !showMore"
        class="showMore"
        @click="showMore = true"
      >
        <i class="icon iconfont up">&#xe657;</i>
        <i class="icon iconfont down">&#xe657;</i>
        {{TLang('查看更多','my')}}
      </div>
    </div>
  </div>
</template>

<script>
import { unionFlag } from '@utils';
export default {
  props: {
    catList: {
      type: Array,
      default: function(){
        return [];
      },
    },
    onChange: Function,
  },
  data(){
    return {
      showMore: false,
      activeItem: {},
      union: unionFlag(),
      right_content_top: 0,
    };
  },
  methods: {
    getCateforyName(category){
      const nameArr = category.compositeCategories.reduce((prev, cur) => {
        prev.push(cur.name);
        return prev;
      }, []);
      return nameArr.join('/');
    },
    prevent(e) {
      e.preventDefault();
    },
  },
};
</script>

<style lang="less">
.cat-list{
  width: 220px;
  margin-top: -44px;
  position: relative;
  margin-left: 20px;
  .drap_down{
    width: 220px;
    background: linear-gradient(
      315deg,
      rgba(92, 180, 236, 1) 0%,
      rgba(61, 150, 226, 1) 100%
    );
    font-size: 16px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    line-height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .list-wrap{
    height: 455px;
    box-shadow:0px 0px 16px 0px rgba(0,0,0,0.1);
    position: relative;
    // overflow-y: scroll;
    // max-height: 60vh;
    .drap_down-item {
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        display: flex;
        padding-left: 15px;
        padding-right: 10px;
        align-items: center;
        position: relative;
        white-space: nowrap;
        // background:rgba(243,243,243,1);
        height: 45px;
        line-height: 44px;
        cursor: pointer;
        &:hover{
          background: #ECF5FD;
          i{
            color: #3D96E2;
          }
        }
        img {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
        i {
          transform: rotate(90deg);
          margin-left: auto;
          font-size: 20px;
        }
        .catefory-list{
          display: flex;
          margin-left: 12px;
          width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          li{
            width: 100%;
            overflow: hidden;
            display: flex;
          }
          .category-name{
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            &:hover{
              color: #3D96E2;
              font-weight: bold;
            }
          }
          .category-line{
            margin: 0 4px;
            color: #B2B2B2
          }
        }
        &::after {
          content: "";
          display: inline-block;
          height: 1px;
          width: 100%;
          background: #f7f7f7;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        // &:hover{
        //   color: #fff;
        //   background:linear-gradient(315deg,rgba(92,180,236,1) 0%,rgba(61,150,226,1) 100%);
        //   box-shadow:2px 2px 6px 0px rgba(61,150,226,0.4);
        //   cursor: pointer;
        //   &:after {
        //     background:linear-gradient(315deg,rgba(92,180,236,1) 0%,rgba(61,150,226,1) 100%);
        //   }
        // }
      }
      .rigth_content{
        display: block;
        top: 0;
        left: 100%;
        position: absolute;
        z-index: 11;
        top: 0px;
        width: 680px;
        background: #fff;
        padding: 0 30px;
        height: 550px;
        box-shadow:0px 0px 8px 0px rgba(0,0,0,0.1);
        box-sizing: border-box;
        overflow: hidden;
        overflow-y: scroll;
        li{
          padding-top: 30px;
          padding-bottom: 20px;
        }
        &:hover{
          cursor: pointer;

        }
        p {
          font-size: 18px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: left;
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .get-more{
            display: flex;
            font-size: 12px;
            align-items: center;
            line-height: 16px;
            &:hover{
              color: #3D96E2;
            }
            i {
              transform: rotate(90deg);
              // margin-left: -4px;
              font-size: 16px;
            }
          }
          &:after {
            content: "";
            display: inline-block;
            width: 630px;
            height: 1px;
            background: #f0f0f0;
            position: absolute;
            bottom: -10px;
            left: 0;
          }
        }
          .sub-list {
            display: flex;
            flex-wrap: wrap;
            font-size: 12px;
            color: rgba(51, 51, 51, 1);
            max-height: 300px;
            overflow-y: scroll;
            margin-top: 26px;
            .sub3-item {
              margin-right: 20px;
              margin-bottom: 10px;
            }
            .sub3-item:hover {
              font-size: 12px;
              // font-weight: bold;
              color: rgba(61, 150, 226, 1);
              cursor: pointer;
            }
          }
      }
      .showMore{
        position: absolute;
        bottom: 0;
        text-align: center;
        width: 100%;
        height:44px;
        background:linear-gradient(180deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0.8) 61%,rgba(255,255,255,1) 100%);
        line-height: 44px;
        color: #3D96E2;
        i{
          position: absolute;
          left: 62px;
          transform: rotate(180deg);
        }
        i.down{
          top: 3px;
        }
        i.up{
          top: -2px;
        }
        &:hover{
          cursor: pointer;
        }
      }
    }

    .showMoreHeigth{
      height: auto;
      overflow-y: visible;
    }
  }
</style>